export default {
    values: {
        'View Database': 'View Database',
        'Database Configuration': 'Database Configuration',
        'Delete Database': 'Delete Database',

        'Last Update': 'Last Update',
        'Last Update by':'Last Update by',
        'Search for a Database':'Search for a Database',
        'Success': 'Success',
        'Data imported!': 'Data Imported!',

        'Perspective': 'Perspective', 
        'Configuration': 'Configuration',
        'Full App config': 'Full App config',
        'Save': 'Save',
        'cancel': 'cancel',

        'Loading...': 'Loading...',
        'Importing': 'Importing',

        'Importing spreadsheet data...': 'Importing spreadsheet data...',
        'Data is being uploaded': 'Data is being uploaded',
        'Error importing spreadsheet. Check the file and try again.': 'Error importing spreadsheet. Check the file and try again.',

        'Availability': 'Availability',
        'Requests without errors': 'Requests without errors',
        'No events in this period': 'No events in this period',

        'Year': 'Year',
        'Month': 'Month',
        'Day': 'Day',
        'Hour': 'Period',
        'Period': 'Period',
        'Sample': 'Sample',
        'Requests': 'Requests',
        'Errors': 'Errors',
        'SLA': 'SLA',
        'Application': 'Application',
        'Back': 'Back',

        'Quick navigation': 'Quick navigation',
        'this year': 'this year',
        'this month': 'this month',
        'today': 'today',
        'now': 'now',

        'SLA this year': 'Availability this year',
        'SLA in the year': 'Availability in the year',
        'SLA this month': 'Availability this month',
        'SLA in the month': 'Availability in the month',
        'SLA today': 'Availability today',
        'SLA in the day': 'Availability in the day',
        'Choose the': 'Choose the',

        'January': 'January',
        'February': 'February',
        'March': 'March',
        'April': 'April',
        'May': 'May',
        'June': 'June',
        'July': 'July',
        'August': 'August',
        'September': 'September',
        'October': 'October',
        'November': 'November',
        'December': 'December',

        'Jan': 'Jan',
        'Feb': 'Feb',
        'Mar': 'Mar',
        'Apr': 'Apr',
        'Jun': 'Jun',
        'Jul': 'Jul',
        'Aug': 'Aug',
        'Sep': 'Sep',
        'Oct': 'Oct',
        'Nov': 'Nov',
        'Dec': 'Dec'
    }
};
